<script setup>
import { defineProps, toRefs, defineEmits, ref, defineExpose, inject, } from 'vue';
import { useRoute } from "vue-router";
import CountryFlag from 'vue-country-flag-next'
import countryListData from '@/utils/country.js';
// import flatPickr from "vue-flatpickr-component";
import i18n from "@/i18n"
import { getLangValue } from "@/utils/common"; //获取后端语言
const props = defineProps({
    formData: {
        type: Object,
        required: true,
        default: () => { }
    }
})
const emits = defineEmits(["update:formData"])
const { formData } = toRefs(props)
const route = useRoute()
const current_hscode = inject("current_hscode") // 当前选中的hscode
const isCheckForm = ref(false)
const countryList = ref(countryListData); // 国家数据
const countryList1 = ref(countryListData); // 国家数据
// const typeRef1 =ref(null)

const isDecimal = (num) => {
    //? 是否数字
    return /^\d+(\.\d+)?$/.test(num.toString());
}
const isDecimalWithTwoPlaces = (num) => {
    //? 是否两位数字 
    return /^\d+(\.\d{1,2})?$/.test(num.toString());
}

const getDetailValue = (key) => {
    // 根据key 获取value
    let obj = formData.value.fieldsList.find(item => item.key == key)
    return obj ? obj.value : ''
}

const checkForm = () => {
    // 验证form 信息
    isCheckForm.value = true
    let checkResult = true
    let message = '';
    for (let k in formData.value.fieldsList) {
        // console.log(formData.value);
        if (formData.value.fieldsList[k].key == 'template_info_supply_chain') {
            // 数据库公开类型 =3 供应链公开需要填写供应链 
            if (getDetailValue('template_info_public_type') == 3 && (!formData.value.fieldsList[k].value || formData.value.fieldsList[k].value.length == 0)) {
                checkResult = false
                break;
            }
            // 如果不是对供应链 就把选择的值置空
            if (getDetailValue('template_info_public_type') != 3) {
                formData.value.fieldsList[k].value = []
            }
        } else if (formData.value.fieldsList[k].required) {
            //  必填项
            if (formData.value.fieldsList[k].value === "" || formData.value.fieldsList[k].value === null) {
                checkResult = false
                break;
            }
            // }
        }
        // 判断库存
        if ((formData.value.fieldsList[k].key == 'product_info_base_info_inventory' || formData.value.fieldsList[k].key == 'product_info_base_info_batch_size') && (formData.value.fieldsList[k] !== '' && formData.value.fieldsList[k].value !== null)) {
            console.log(formData.value.fieldsList[k]);
            if (!Number.isInteger(formData.value.fieldsList[k].value) || formData.value.fieldsList[k].value < 0) {
                checkResult = false
                // 设置特殊的信息
                document.querySelector('#numberproduct_info_base_info_inventory').classList.add('is-invalid')
                message = getLangValue('product-template', 'integerMessage')
                break;
            } else {
                document.querySelector('#numberproduct_info_base_info_inventory').classList.remove('is-invalid')
            }
        }
        // 判断价格  整数 或者 小数小数保留2位以内
        if (formData.value.fieldsList[k].key == 'product_info_base_info_price' && (formData.value.fieldsList[k] !== '' && formData.value.fieldsList[k].value !== null)) {
            if (formData.value.fieldsList[k].value < 0 || (isDecimal(formData.value.fieldsList[k].value) && !isDecimalWithTwoPlaces(formData.value.fieldsList[k].value))) {
                checkResult = false
                // 设置特殊的信息
                document.querySelector('#numberproduct_info_base_info_price').classList.add('is-invalid')
                message = getLangValue('product-template', 'priceMessage')
                break;
            } else {
                document.querySelector('#numberproduct_info_base_info_price').classList.remove('is-invalid')
            }
        }
    }
    for (let k in formData.value.addfieldsList) {
        if (formData.value.addfieldsList[k].required && !formData.value.addfieldsList[k].value) {
            checkResult = false
            break;
        }
    }
    // console.log(checkResult);
    return { checkResult, message };
}

const changeHscode = (node) => {
    // hscode 改变时的操作
    current_hscode.value = node
    // 修改描述
    formData.value.fieldsList[1].value = ''
    if (node) {
        let arr = formData.value.fieldsList[0].list.filter(element => element.id == node[0]);
        if (arr.length) {
            let arr1 = arr[0].children.filter(element => element.id == node[1])
            // console.log(arr1);
            if (arr1.length) {
                // console.log(arr1[0].description);
                formData.value.fieldsList[1].value = arr1[0].description ? arr1[0].description : '-'
            }
        }
    }
}

const changeValue = (key, e) => {
    // plid改变时的操作
    if (key == 'PLID') {
        const val = e.target.value
        for (let k in formData.value.fieldsList) {
            if (formData.value.fieldsList[k].key == 'PID') {
                formData.value.fieldsList[k].prefix = `${formData.value.fieldsList[k - 1].prefix}${val}`
                emits('update:formData', formData.value)
                break;
            }
        }
    }
}


const filterCountry = (query) => {
    // 过滤国名
    if (query) {
        countryList.value = countryList1.value.filter((item) => {
            if ((item.zh.toLowerCase()).includes(query.toLowerCase())) {
                return true
            }
        })
    } else {
        countryList.value = [...countryList1.value] //val为空时，还原数组
    }
}
const refs = ref([]);
const addRefs = (i) => {
    return (el) => {
        refs.value[i] = el;
        // refs.value[0].togglePopperVisible(true)
    };
}

const blurValue = (index) => {
    /**
     * ? 限制批次号长度为12
     * ? 限制尺寸长度为10 只能输入字母、数字和字符
     */
    // 特殊处理批次号
    // console.log(index);
    // console.log(formData.value.fieldsList[index]);
    if (formData.value.fieldsList[index].key == 'product_info_base_info_batch_number' || formData.value.fieldsList[index].key == 'product_info_base_info_size') {
        // 最大保留10位
        formData.value.fieldsList[index].value = formData.value.fieldsList[index].key == 'product_info_base_info_batch_number' ? formData.value.fieldsList[index].value.slice(0, 12) : formData.value.fieldsList[index].value.slice(0, 10)
        if (formData.value.fieldsList[index].key == 'product_info_base_info_size') {
            // const allowedCharacters = /^[a-zA-Z0-9!@#$%^&*()+=._-]*$/; 
            const allowedCharacters = /^[a-zA-Z0-9!@#$%^&*)(+=._\-,]+$/;
            if (!allowedCharacters.test(formData.value.fieldsList[index].value)) {
                formData.value.fieldsList[index].value = formData.value.fieldsList[index].value.replace(/[^a-zA-Z0-9!@#$%^&*)(+=._\-,]/g, "");
            }
        }
    }
}

defineExpose({
    emits,
    checkForm,
})

</script>
<template>
    <b-card>

        <div class="row gy-3 w-100">
            <!-- <div class="row" v-if="route.query.type== 'add' && !formData.title">
                <label class="form-label">
                    <span class="text-danger">*</span>
                    <span>模板名称</span>
                </label>
                <div style="height: 40px;">
                    <el-select v-model="templateId" placeholder=" " size="large" style="width: 100%;">
                        <el-option v-for="item1 in templateList" :key="item1.value" :label="item1.label"
                            :value="item1.value" />
                    </el-select>
                </div>
            </div> -->
            <div v-if="formData.title"
                style="font-weight: 500;border-bottom: 1px solid #E9EBEC; margin: 10px 0;font-size: 16px; height: 40px; line-height: 40px;">
                {{ i18n.global.locale == 'en' ? formData.title_en : formData.title }}
            </div>
            <div class="row  d-flex justify-content-start my-form">
                <template v-for="(item, index) in formData.fieldsList" :key="index">
                    <div class="col-4 mt-2" v-if="item.key !== 'template_info_supply_chain'">
                        <label class="form-label">
                            <span class="text-danger" v-if="item.required">*</span>
                            <span>{{ i18n.global.locale == 'en' ? item.label_en : item.label }}</span>
                            <span>{{ i18n.global.locale == 'en' ? item.extra?.label_en : item.extra?.label }}</span>
                        </label>
                        <div style="height: 37.5px;">
                            <el-cascader :ref="addRefs(index)" id="typeHscode" @change="changeHscode" size="large"
                                v-if="item.type === 'list'" v-model="item.value" style="width: 100%;"
                                :options="item.list"
                                :disabled="route.query.type == 'view' || (item.extra && item.extra.disabled)"
                                :show-all-levels="false" :title="item.disabled ? '关联数据无法修改HScode' : ''"
                                :props="{ label: 'title', value: 'id', children: 'children', }" placeholder=" "
                                clearable :class="[
                                    (isCheckForm && !item.value.length) &&
                                    'is-invalid',
                                ]" />
                            <el-select :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                                v-else-if="item.type === 'select'" v-model="item.value" placeholder=" " size="large"
                                style="width: 100%;" clearable
                                :disabled="route.query.type == 'view' || (item.extra && item.extra.disabled)">
                                <el-option v-for="item1 in item.list" :key="item1.id" :label="item1.label"
                                    :value="item1.value" />
                            </el-select>
                            <el-select :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                                v-else-if="item.type === 'country'" v-model="item.value" filterable placeholder=" "
                                size="large" style="width: 100%;" clearable :disabled="route.query.type == 'view'"
                                :filter-method="filterCountry">
                                <el-option v-for="item1 in countryList" :key="item1.key" :label="item1.zh"
                                    :value="item1.key">
                                    <country-flag :country='item1.key' size='small' /> {{ item1.zh }}
                                </el-option>
                            </el-select>
                            <el-select :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                                v-else-if="item.type === 'select_hidden'" v-model="item.value" placeholder=" "
                                size="large" style="width: 100%;" clearable
                                :disabled="route.query.type == 'view' || (item.extra && item.extra.disabled)">
                                <el-option v-for="item1 in item.list" :key="item1.value" :label="item1.label"
                                    :value="item1.value" />
                            </el-select>
                            <!-- <input v-else-if="item.key=='颜色'"  type="color" class="form-control form-control-color w-100" id="colorPicker" v-model="item.value"> -->
                            <input v-else-if="item.type == 'number'" type="number" clearable class="form-control"
                                v-model="item.value" :id="`number${item.key}`"
                                :class="[(isCheckForm && (item.value === '' || item.value === null) && item.required) && 'is-invalid']"
                                required :disabled="route.query.type == 'view'" />
                            <div class="input-group h-100" v-else-if="item.type == 'number1'">
                                <input type="number" clearable class="form-control" v-model="item.value"
                                    :id="`number${item.key}`"
                                    :class="[(isCheckForm && (item.value === '' || item.value === null) && item.required) && 'is-invalid']"
                                    required :disabled="route.query.type == 'view'" />
                                <!-- <div class="input-group-text h-100">
                                    <select v-model="item.unit" class="form-select form-select-sm"
                                        aria-label=".form-select-sm example"
                                        style="border:unset; background-color: #f0f2f6;">
                                        <option value="¥">{{ getLangValue('product-template', 'rmb') }}</option>
                                        <option value="$">{{ getLangValue('product-template', 'dollar') }}</option>
                                        <option value="£">{{ getLangValue('product-template', 'pound') }}</option>
                                        <option value="€">{{ getLangValue('product-template', 'euro') }}</option>
                                    </select>
                                </div> -->
                            </div>
                            <!-- 日期格式 -->
                            <!-- <flat-pickr :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                                v-else-if="item.type == 'date'" v-model="item.value" style="background-color: unset;"
                                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                                class="form-control"></flat-pickr> -->
                            <el-date-picker :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']" style="width: 100%;"
                            v-else-if="item.type == 'date'" v-model="item.value" type="datetime" placeholder=""
                                format="YYYY-MM-DD HH:mm" date-format="YYYY-MM-DD" time-format="HH:mm" />
                            <div v-else>
                                <div class="input-group h-100 d-flex" v-if="item.key == 'PLID' || item.key == 'PID'">
                                    <div class="input-group-text flex-1"
                                        style="min-width: 50%; padding: 0px 2px; background-color: #CED4DA;">
                                        <input v-if="item.key == 'PLID'" clearable class="form-control"
                                            v-model="item.prefix" style="background-color: #cfd4d9;" required
                                            :disabled="route.query.type == 'view'" />
                                        <span v-else>{{ item.prefix }}</span>
                                    </div>
                                    <input clearable class="form-control flex-1" v-model="item.value"
                                        @change="changeValue(item.key, $event)"
                                        :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                                        required :disabled="route.query.type == 'view'" />

                                </div>
                                <template v-else>
                                    <template v-if="
                                        item.key == 'template_info_template_name' ||
                                        item.key == 'template_info_destination_market' ||
                                        item.key == 'template_info_description'
                                    ">
                                        <input v-show="i18n.global.locale == 'en'" clearable class="form-control"
                                            v-model="item.value_en" @blur="blurValue(index)" required
                                            :disabled="route.query.type == 'view' || (item.extra && item.extra.disabled)" />
                                        <input v-show="i18n.global.locale == 'ch'" clearable class="form-control"
                                            v-model="item.value" @blur="blurValue(index)" required
                                            :disabled="route.query.type == 'view' || (item.extra && item.extra.disabled)" />
                                    </template>
                                    <input v-else clearable class="form-control" v-model="item.value"
                                        @blur="blurValue(index)"
                                        :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                                        required
                                        :disabled="route.query.type == 'view' || (item.extra && item.extra.disabled)" />
                                </template>

                            </div>
                        </div>
                    </div>
                    <div class="col-4 mt-2" v-else v-show="formData.fieldsList[4].value == 3">
                        <label class="form-label">
                            <span class="text-danger" v-if="item.required">*</span>
                            <span>{{ i18n.global.locale == 'en' ? item.label_en : item.label }}</span>
                        </label>
                        <div style="height: 40px;">
                            <el-select
                                :class="[(isCheckForm && (!item.value || item.value.length == 0) && formData.fieldsList[4].value == 3) && 'is-invalid']"
                                v-model="item.value" placeholder=" " size="large" style="width: 100%;" clearable
                                multiple collapse-tags
                                :disabled="route.query.type == 'view' || (item.extra && item.extra.disabled)">
                                <el-option v-for="item1 in item.list" :key="item1.id" :label="item1.name"
                                    :value="item1.id" />
                            </el-select>
                        </div>
                    </div>
                </template>
                <!-- 新增字段部分 -->
                <div class="col-4 mt-2" v-for="(item, index) in formData.addfieldsList" :key="index">
                    <label class="form-label">
                        <span class="text-danger" v-if="item.required">*</span>
                        <span>{{ i18n.global.locale == 'en' ? item.name_en : item.name }}</span>
                    </label>
                    <div class="d-flex align-items-center">
                        <input :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                            :disabled="route.query.type == 'view'" clearable v-model="item.value" class="form-control"
                            style="display: inline; flex:1" />
                    </div>
                </div>
            </div>
        </div>
    </b-card>
</template>
<style scoped>
.is-invalid {
    border: 1px solid #f06548;
    border-radius: 4px;
}

.xxxx {
    display: block !important;
    z-index: 1111;
}

.my-form {
    .form-control:disabled {
        background-color: #f5f7fa;
        cursor: not-allowed;
    }
}

:deep(.el-select__wrapper) {
    height: 100%;
}

:deep(.el-date-editor--datetime) {
    height: 100%;
}

:deep(.el-date-editor--datetime .el-input__inner) {
    color: #222529;
    font-size: 0.8125rem !important;;
}
</style>

<style>
/* 修改原来的日期插件 */
/* .flatpickr-months{
    background-color: unset !important;
}

.flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month{
    color: #303133 !important;
} */
</style>